import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ChevronLeft, ArrowRight } from "lucide-react";
import api from "../services/api";
import Pop from "../components/PopupForm";

const BlogDetail = () => {

  const { slug } = useParams();
  const navigate = useNavigate();

  const [blog,setBlog] = useState(null);
  const [blogs,setBlogs] = useState([]);
  const [categories,setCategories] = useState([]);

  const [showForm, setShowForm] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [date, setDate] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      blogId: blog._id,
      name,
      email,
      phone,
      address,
      date,
      message,
    };

    try {
      await api.post("/comments", formData);

      alert("Comment submitted successfully");
    } catch (error) {
      alert("Failed to submit comment");
    }
  };

  useEffect(()=>{

    const fetchData = async ()=>{
      const [postsRes,catsRes] = await Promise.all([
        api.get("/posts"),
        api.get("/categories")
      ]);

      setBlogs(postsRes.data);
      setCategories(catsRes.data);

      const found = postsRes.data.find(b=>b.slug===slug);
      setBlog(found);
    };

    fetchData();

  },[slug]);

  if(!blog) return <div className="text-center py-32">Loading...</div>;

  const getImageUrl = (blog)=>{
    const path = blog.featuredImage?.url;
    if(!path) return "";
    if(path.startsWith("http")) return path;

    const baseUrl =
      process.env.REACT_APP_API_URL?.replace("/api","") ||
      "http://localhost:5000";

    return `${baseUrl}${path}`;
  };

  const imageUrl = getImageUrl(blog);

  return (

    <div className="min-h-screen bg-gray-50 pb-20">

      {/* Top Header */}
      <div className="bg-white border-b p-4 flex justify-between items-center sticky top-0 z-40">
        <button
          onClick={()=>navigate("/blogs")}
          className="flex items-center gap-2 text-[#0a328a] font-semibold hover:underline"
        >
          <ChevronLeft size={18}/>
          Back to Blogs
        </button>
      </div>

      {/* Hero Banner */}
      <div className="bg-[#0a328a] text-white py-16 text-center">
        <h1 className="text-4xl font-bold tracking-wide">
          BLOG DETAILS
        </h1>
        <p className="text-sm text-blue-200 mt-2">
          Home › Blog Details
        </p>
      </div>

      {/* Main Container */}
      <div className="max-w-7xl mx-auto px-6 mb-10 py-14 grid grid-cols-1 lg:grid-cols-3 gap-10">

        {/* LEFT BLOG */}
        <div className="lg:col-span-2 bg-white rounded-xl shadow p-6">

          <img
            src={imageUrl}
            className="w-full h-96 object-cover rounded-lg mb-6"
            alt=""
          />

          <h2 className="text-2xl font-bold mb-3">
            {blog.title}
          </h2>

          <p className="text-gray-400 text-sm mb-6">
            {new Date(blog.createdAt).toDateString()}
          </p>

          <div
            className="prose max-w-none"
            dangerouslySetInnerHTML={{__html:blog.content}}
          />
          <div className="mt-16 bg-white border rounded-xl p-8 shadow-sm">
            <h3 className="text-2xl font-bold mb-8">Leave A Comment</h3>

            <form
              onSubmit={handleSubmit}
              className="grid grid-cols-1 md:grid-cols-2 gap-6"
            >
              <input
                type="text"
                placeholder="Your Name"
                className="bg-gray-100 rounded-full px-5 py-3 outline-none"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />

              <input
                type="email"
                placeholder="Your Email"
                className="bg-gray-100 rounded-full px-5 py-3 outline-none"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <input
                type="text"
                placeholder="Your Phone"
                className="bg-gray-100 rounded-full px-5 py-3 outline-none"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />

              <input
                type="date"
                className="bg-gray-100 rounded-full px-5 py-3 outline-none"
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />

              <input
                type="text"
                placeholder="Your Address"
                className="bg-gray-100 rounded-full px-5 py-3 outline-none md:col-span-2"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />

              <textarea
                placeholder="Type your message"
                rows="5"
                className="bg-gray-100 rounded-2xl px-5 py-3 outline-none md:col-span-2"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>

              <div className="md:col-span-2 flex justify-center mt-4">
                <button
                  type="submit"
                  className="flex items-center gap-3 bg-[#0a328a] text-white px-10 py-3 rounded-full font-semibold hover:bg-blue-900 transition"
                >
                  Send Message
                  <ArrowRight size={18} />
                </button>
              </div>
            </form>
          </div>

        </div>

        {/* RIGHT SIDEBAR */}
        <div className="space-y-8">

          {/* Categories */}
          <div className="bg-white p-5 rounded-xl shadow">
            <h3 className="font-bold mb-4">
              Categories
            </h3>

            <ul className="space-y-3 text-sm">
              {categories.map((cat)=>(
                <li
                  key={cat._id}
                  onClick={()=>navigate(`/blogs?category=${cat.slug}`)}
                  className="flex justify-between cursor-pointer hover:text-[#0a328a]"
                >
                  <span>{cat.name}</span>
                  <span className="text-gray-400">
                    ({cat.postCount})
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Recent Posts */}
          <div className="bg-white p-5 rounded-xl shadow">

            <h3 className="font-bold mb-4">
              Recent Posts
            </h3>

            <div className="space-y-4">

              {blogs.slice(0,3).map(post=>(
                <div
                  key={post._id}
                  onClick={()=>navigate(`/blogs/${post.slug}`)}
                  className="flex gap-3 cursor-pointer group"
                >

                  <img
                    src={getImageUrl(post)}
                    className="w-16 h-16 object-cover rounded"
                    alt=""
                  />

                  <div>

                    <p className="text-sm font-semibold group-hover:text-[#0a328a] line-clamp-2">
                      {post.title}
                    </p>

                    <span className="text-xs text-gray-400">
                      {new Date(post.createdAt).toLocaleDateString()}
                    </span>

                  </div>

                </div>
              ))}

            </div>

          </div>

        </div>

      </div>

      {/* CTA */}

      <div className="max-w-5xl w-full mx-auto mt-12 mb-16 p-8 bg-gradient-to-br from-blue-700 to-[#0a328a] rounded-xl text-white flex flex-col md:flex-row items-center gap-8">

        <div>
          <h3 className="text-xl font-bold">
            Expert Guidance at Your Doorstep
          </h3>

          <p className="text-blue-100 text-sm">
            Book a personalized counseling session at home.
          </p>
        </div>

        <button
          onClick={()=>setShowForm(true)}
          className="flex items-center gap-2 bg-white text-[#0a328a] px-5 py-3 rounded-lg font-semibold"
        >
          Door Step Counselling
          <ArrowRight size={18}/>
        </button>

        <Pop show={showForm} onClose={()=>setShowForm(false)}/>

      </div>

    </div>

  );
};

export default BlogDetail;